import { motion } from 'framer-motion';
import { fadeInUp } from '../../lib/animations';

const STEPS = [
  {
    step: '01',
    title: 'Choose Your Artist',
    description: 'Browse our roster of top dancehall and reggae artists. Each has their own pricing and delivery time.',
  },
  {
    step: '02',
    title: 'Send Your Message',
    description: 'Write what you want the artist to say. Include names, shoutouts, or any custom content.',
  },
  {
    step: '03',
    title: 'Get Your Dubplate',
    description: 'Once accepted, your dubplate will be delivered within the specified timeframe. Payment held securely until delivery.',
  },
];

export function HowItWorksSection() {
  return (
    <section className="py-20 bg-surface">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={fadeInUp.initial}
          whileInView={fadeInUp.animate}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="font-heading text-3xl sm:text-4xl font-bold mb-4">How It Works</h2>
          <p className="text-[#A1A1AA] max-w-xl mx-auto">
            Getting your custom dubplate is simple. Just follow these steps.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {STEPS.map((item, idx) => (
            <motion.div
              key={item.step}
              initial={fadeInUp.initial}
              whileInView={fadeInUp.animate}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}
              className="relative p-8 bg-surface-highlight rounded-2xl border border-[#262626]"
            >
              <div className="font-mono text-5xl font-bold text-lime/20 absolute top-4 right-4">{item.step}</div>
              <h3 className="font-heading text-xl font-bold mb-3">{item.title}</h3>
              <p className="text-[#A1A1AA] text-sm">{item.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
